import { Form } from 'react-final-form';
import { onSubmit, onValidate } from './SettingsSecretarySubmit';
import SwipeableViews from 'react-swipeable-views';
import { useTheme } from '@emotion/react';
import { useEffect, useState } from 'react';
import SettingsSecretaryFormStepOne from './SettingsSecretarySteps/SettingsSecretaryFormStepOne';
import SettingsSecretaryFormStepTwo from './SettingsSecretarySteps/SettingsSecretaryFormStepTwo';

const SettingsSecretaryForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update } = props;
  const [initialValues, setInitialValues] = useState(null); 

  useEffect(() => {
    if (update) {
      setInitialValues(props.initialValues);
      return;
    }
    // eslint-disable-next-line
  }, []);

  return (
    <Form  
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, {...props, initialValues:initialValues})}
      validate={(val)=>onValidate(val,props)}
    >
      {({ handleSubmit }) => (
        <form
          id={props.formName}
          onSubmit={handleSubmit}
          className="SettingsSecretaryForm"
        >
          <SwipeableViews
            axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
            index={step}
            onChangeIndex={(index) => setStep(index)}
          >
            <SettingsSecretaryFormStepOne />
            <SettingsSecretaryFormStepTwo />
          </SwipeableViews>
        </form>
      )}
    </Form>
  );
};

export default SettingsSecretaryForm;